<template>
  <div class="container">
    <div class="row my-4">
      <div class="col-md-12 text-center">
        <h2>{{ $t('message.pageNotFound') }} !</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "PageNotFound",
  mounted: function() {
    this.setStoreLoaded();
  },
  methods: {
    ...mapMutations(["setStoreLoaded"])
  }
};
</script>
